// Folio Charge model
import { useStore } from "storev2/formStore";
import dates from "tools/dates";

const model = "hotel.folio.charge";

function onSearchProduct() {
  const res = [
    ["account_category", "!=", null],
    ["salable", "=", true],
  ];
  return res;
}

function onChangeValue(record) {
  const { store, active } = record;
  const { updateRecord } = useStore.getState();
  if (active.product) {
    active.amount = (Number(active.unit_price_w_tax) * Number(active.quantity))
      .toFixed(2)
      .toString();
  }
  updateRecord(active, store, model, active.id);
}

function onChangeProduct(record) {
  const { store, active } = record;
  const { updateRecord } = useStore.getState();
  if (active.product) {
    const product = active.product;
    const unit_price = product.list_price;
    const sale_price_taxed = active.product.sale_price_taxed;
    const fmt_unit_price = unit_price; //.toFixed(2); //.toString();
    store.unit_price = fmt_unit_price;
    active.unit_price = unit_price;
    store.unit_price_w_tax = sale_price_taxed;
    active.unit_price_w_tax = sale_price_taxed;
    if (active.quantity) {
      active.amount = active.quantity * sale_price_taxed;
    }
  }
  updateRecord(active, store, model, active.id);
}

function getAmount(record) {
  const res = 0;
  if (record.unit_price_w_tax && record.quantity) {
    record.amount = record.unit_price_w_tax * Number(record.quantity); //.toFixed(2);
  }
}

function onAccessEdit(record) {
  return record.status !== "draft";
}

function onAccess(record) {
  return record.status === "draft";
}

function getRoom(record) {
  return record?.folio?.room;
}

function layout(props) {
  const selectable = props?.selectable;
  const table_action = props ? props.table_action : ["add", "edit"];
  const ctxView = {
    model: model,
    form_action: ["add", "edit", "delete"],
    table_action: table_action,
    domain: [],
    orderBy: [["sale_date", "ASC"]],
    limit: 100,
    autoSave: true,
    selectable: selectable,
    target: "folio",
    access: {
      delete: onAccess,
      edit: onAccess,
    },
    fields: {
      sale_date: {
        type: "date",
        default: dates.dateToday(),
        required: true,
        readOnly: onAccessEdit,
      },
      kind: {
        type: "selection",
        readOnly: true,
        default: { id: "product", name: "product" },
        translate: true,
        options: [
          { id: "product", name: "product" },
          { id: "accommodation", name: "accommodation" },
        ],
      },
      amount: {
        type: "numeric",
        readOnly: true,
        function: getAmount,
        decimalPlaces: 2,
      },
      status: {
        type: "char",
        readOnly: true,
        translate: true,
        default: "draft",
      },
      folio: {
        type: "many2one",
        model: "hotel.folio",
        readOnly: true,
      },
      description: {
        type: "char",
        readOnly: true,
      },
      invoice_line: {
        type: "many2one",
        model: "account.invoice.line",
        readOnly: true,
      },
      product: {
        type: "many2one",
        model: "product.product",
        required: true,
        readOnly: onAccessEdit,
        recSearch: onSearchProduct,
        withChange: onChangeProduct,
        attrs: [
          "id",
          "list_price",
          "name",
          "sale_price_taxed",
          "sale_uom.rec_name",
        ],
      },
      quantity: {
        type: "integer",
        default: 1,
        required: true,
        withChange: onChangeValue,
        readOnly: onAccessEdit,
        decimalPlaces: 2,
      },
      order: {
        type: "char",
        readOnly: true,
        // default: 1,
      },
      unit_price_w_tax: {
        type: "numeric",
        required: true,
        decimalPlaces: 2,
        withChange: onChangeValue,
        readOnly: onAccessEdit,
      },
    },
    list: [
      { name: "sale_date", width: "10%" },
      { name: "product", width: "25%" },
      { name: "description", width: "15%" },
      { name: "quantity", width: "10%" },
      { name: "unit_price_w_tax", width: "20%" },
      // { name: "amount", width: "15%" },
      // { name: "status", width: "15%" },
    ],
    form: [
      { name: "product" },
      {
        type: "grid",
        name: "grid1",
        elements: [{ name: "sale_date" }, { name: "folio" }],
        colSpan: "col-span-1",
      },
      {
        type: "grid",
        name: "grid2",
        elements: [{ name: "quantity" }, { name: "unit_price_w_tax" }],
        colSpan: "col-span-1",
      },
      {
        type: "grid",
        name: "grid3",
        elements: [{ name: "amount" }, { name: "status" }],
        colSpan: "col-span-1",
      },
      { name: "order" },
      { name: "invoice_line" },
    ],
  };

  return ctxView;
}

export { layout };
